import { useTranslation } from 'react-i18next'

import { InputWithLabel } from '@reveni-io/reveni-ui'

const MaxDurationForExchanges = ({ maxDurationForExchanges, setMaxDurationForExchanges, disabled }) => {
  const { t } = useTranslation()

  const handleChange = e => {
    const newValue = e.target.value

    if (Number(newValue) >= 0) {
      setMaxDurationForExchanges(newValue)
    } else {
      setMaxDurationForExchanges('')
    }
  }

  const getError = () => {
    if (!maxDurationForExchanges) {
      return t('Este campo es requerido')
    }
  }

  return (
    <InputWithLabel
      backgroundColor="white"
      value={maxDurationForExchanges}
      onChange={handleChange}
      label={t('Plazo para cambios (días naturales)')}
      error={getError()}
      helperText={getError()}
      disabled={disabled}
    />
  )
}

export default MaxDurationForExchanges
